export const modelNameMap = {
  BRONCO: "BRONCO",
  CAPRI: "CAPRI",
  CONNECT: "CONNECT",
  "CONNECT TOURNEO ICE": "CONNECT",
  "CONNECT TOURNEO PHEV": "CONNECT",
  "CONNECT TRANSIT ICE": "CONNECT",
  "CONNECT TRANSIT PHEV": "CONNECT",
  COURIER: "COURIER",
  "COURIER TOURNEO BEV": "COURIER",
  "COURIER TOURNEO ICE": "COURIER",
  "COURIER TRANSIT BEV": "COURIER",
  "COURIER TRANSIT ICE": "COURIER",
  CUSTOM: "CUSTOM",
  "CUSTOM PHEV": "CUSTOM",
  "CUSTOM TOURNEO BEV": "CUSTOM",
  "CUSTOM TOURNEO ICE": "CUSTOM",
  "CUSTOM TOURNEO PHEV": "CUSTOM",
  "CUSTOM TRANSIT BEV": "CUSTOM",
  "CUSTOM TRANSIT ICE": "CUSTOM",
  "CUSTOM TRANSIT PHEV": "CUSTOM",
  "E-COURIER": "E-COURIER",
  "E-EXPLORER": "E-EXPLORER",
  KUGA: "KUGA",
  "KUGA PHEV": "KUGA",
  "MACH-E": "MACH-E",
  "MACH-E NEW": "MACH-E",
  MUSTANG: "MUSTANG",
  "NEW CUSTOM": "CUSTOM",
  PUMA: "PUMA",
  "PUMA GEN-E": "PUMA GEN-E",
  RANGER: "RANGER",
  "RANGER NEW": "RANGER",
  "RANGER PHEV": "RANGER PHEV",
  TOURNEOCON: "CONNECT",
  TRANSIT: "TRANSIT",
  "TRANSIT NEW": "TRANSIT",
  "E-TRANSIT": "E-TRANSIT",
  "TRANSIT BEV": "E-TRANSIT",
};
